import { Z_STACK } from '../config/layout'
import { useExperienceStore } from '../store/experienceStore'
import type { QualityTier } from '../config/quality'

export function Hud() {
  const inputMode = useExperienceStore((s) => s.inputMode)
  const gestureModelStatus = useExperienceStore((s) => s.gestureModelStatus)
  const quality = useExperienceStore((s) => s.quality)
  const bannerMessage = useExperienceStore((s) => s.bannerMessage)
  const showPersonPreview = useExperienceStore((s) => s.showPersonPreview)
  const showSkeleton = useExperienceStore((s) => s.showSkeleton)
  const cameraGranted = useExperienceStore((s) => s.cameraGranted)

  return (
    <div className="hud" style={{ zIndex: Z_STACK.ui }}>
      <div className="hud-top">
        <div className="brand">
          <span className="brand-mark">L</span>
          <div>
            <div className="brand-title">Lucy</div>
            <div className="brand-sub">时空手势体验</div>
          </div>
        </div>
        <div className="hud-controls">
          <label className="chip">
            画质
            <select
              value={quality}
              onChange={(e) => {
                useExperienceStore
                  .getState()
                  .setQuality(e.target.value as QualityTier)
                useExperienceStore.getState().setQualityLocked(true)
              }}
            >
              <option value="high">高</option>
              <option value="medium">中</option>
              <option value="low">低</option>
            </select>
          </label>
          <button
            type="button"
            className="chip-btn"
            onClick={() =>
              useExperienceStore.getState().setShowPersonPreview(!showPersonPreview)
            }
          >
            {showPersonPreview ? '隐藏影像' : '显示影像'}
          </button>
          <button
            type="button"
            className="chip-btn"
            onClick={() =>
              useExperienceStore.getState().setShowSkeleton(!showSkeleton)
            }
          >
            骨架 {showSkeleton ? '开' : '关'}
          </button>
          <button
            type="button"
            className="chip-btn"
            onClick={() => useExperienceStore.getState().setOnboardingStep(0)}
          >
            帮助
          </button>
        </div>
      </div>

      <div className="hud-status">
        <span className={`status-pill mode-${inputMode}`}>
          {inputMode === 'gesture'
            ? '手势控制'
            : inputMode === 'keyboard'
              ? '键盘控制'
              : '鼠标控制'}
        </span>
        {cameraGranted && (
          <span className="status-pill">
            手势模型{' '}
            {gestureModelStatus === 'ready'
              ? '就绪'
              : gestureModelStatus === 'loading'
                ? '加载中…'
                : gestureModelStatus === 'failed'
                  ? '失败'
                  : '待命'}
          </span>
        )}
      </div>

      {bannerMessage && (
        <div className="toast" role="status">
          {bannerMessage}
          <button
            type="button"
            onClick={() => useExperienceStore.getState().setBannerMessage(null)}
          >
            ×
          </button>
        </div>
      )}

      <div className="gesture-hints">
        <div>
          <kbd>←</kbd>/<kbd>→</kbd> 流速 · <kbd>Space</kbd> 暂停 · 滚轮 加速 ·
          拖动时间轴
        </div>
      </div>
    </div>
  )
}
